export const appendDateToFilename = (filename) => {
  if (!filename) return filename;
  const today = new Date().toISOString().split('T')[0].replace(/-/g, '');

  const namePart = filename.split('.').slice(0, -1).join('.');
  const extensionPart = filename.split('.').pop();
  return `${namePart}_${today}.${extensionPart}`;
};
export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}/${month}/${day}`;
};
export const convertTo12HourFormat = (timeRange) => {
  if (!timeRange || !timeRange.includes(':')) return '';

  return timeRange
    .split('-')
    .map((time) => {
      if (!time.includes(':')) return ''; // Ensure valid format
      const [hours, minutes] = time.split(':');
      if (isNaN(hours) || isNaN(minutes)) return ''; // Handle non-numeric cases

      const hour = parseInt(hours, 10);
      const ampm = hour >= 12 ? 'PM' : 'AM';
      const formattedHour = hour % 12 || 12;
      return `${formattedHour}:${minutes} ${ampm}`;
    })
    .join(' - ');
};
export const formatToLocal = (dateString) => {
  if (!dateString) return '';

  // Convert manually to UTC
  const [datePart, timePart] = dateString.split(' ');
  if (!datePart || !timePart) return '';

  const [y, m, d] = datePart.split('/').map(Number);
  const [h, i] = timePart.split(':').map(Number);

  const date = new Date(Date.UTC(y, m - 1, d, h, i)); // treat as UTC
  const local = new Date(date); // now it's in local time

  const yy = local.getFullYear();
  const mm = String(local.getMonth() + 1).padStart(2, '0');
  const dd = String(local.getDate()).padStart(2, '0');
  const hh = String(local.getHours()).padStart(2, '0');
  const ii = String(local.getMinutes()).padStart(2, '0');

  return `${yy}/${mm}/${dd} ${hh}:${ii}`;
};
